(function () {
	const flickityCarousel = () => {
		$(".flickity-carousel-section").each(function () {
			if ($(this).hasClass("slider_started")) {
				return "";
			}
			$(this).addClass("slider_started");
			const id = $(this).attr("id");
			const box = $(this).find(".flickity-carousel");
			const autoplay = box.data("autoplay");
			const speed = box.data("speed") * 1000; // Convert speed to milliseconds
			const stopAutoplay = box.data("stop-autoplay");
			const delay = box.data("delay") * 1000;
			let autoplayParm = {};
			if (autoplay) {
				autoplayParm = {
					autoplay: {
						delay: delay,
						pauseOnMouseEnter: stopAutoplay,
						disableOnInteraction: false,
					},
				};
			}

			let swiperParms = {
				speed: speed,
				slidesPerView: 2.5,
				centeredSlides: true,
				spaceBetween: 20,

				breakpoints: {
					576: {
						spaceBetween: 150,
					},
					990: {
						spaceBetween: 240,
					},
					1400: {
						spaceBetween: 290,
					},
					1600: {
						spaceBetween: 590,
					},
				},
				navigation: {
					nextEl: `#${id} .swiper-button-next`,
					prevEl: `#${id} .swiper-button-prev`,
				},
				pagination: {
					el: `#${id} .swiper-pagination`,
					clickable: true,
				},
				...autoplayParm,
			};

			const swiper = new Swiper(`#${id} .swiper`, swiperParms);

			// Apply animations using GSAP
			gsap.fromTo(
				`#${id} .swiper-slide`,
				{ opacity: 0, y: 50 },
				{ opacity: 1, y: 0, duration: 0.5, stagger: 0.2 }
			);

			// Scale down the previous and next slides based on the speed parameter
			gsap.to(`#${id} .swiper-slide-prev, #${id} .swiper-slide-next`, {
				scale: 0.8, // Reduce size to 80%
				duration: delay / 1000, // Convert milliseconds to seconds
			});

			// Reapply the scaling effect whenever the slide changes
			swiper.on("slideChangeTransitionStart", function () {
				gsap.to(`#${id} .swiper-slide`, { scale: 1, duration: delay / 1000 }); // Reset all slides
				gsap.to(`#${id} .swiper-slide-prev, #${id} .swiper-slide-next`, {
					scale: 0.8,
					duration: delay / 1000,
				});
			});
		});
	};

	document.addEventListener("DOMContentLoaded", function () {
		flickityCarousel();
		document.addEventListener("shopify:section:load", function () {
			flickityCarousel();
		});
	});
})();
